import React, { memo } from 'react';
import cls from './MonthModeCharter.module.css';
import classNames from 'classnames';
import { MonthModePosition } from '../MonthModePosition/MonthModePosition';
import { MonthItemCharter } from './MonthItemCharter';
import { useSelector } from 'react-redux';
import { positionSelector } from '../../../../../../../store/reducers/positionSlice/positionSlice';

export const MonthModeCharter = memo(({ charter }) => {
    const { months, opensCharters } = useSelector((state) => state.gantReducer);

    const positions = useSelector(positionSelector.selectEntities);
    const { settings } = useSelector((state) => state.gantReducer);
    const isLabor = charter?.children.some((guid) => positions[guid].type === 'labor');
    const isShowPosition = isLabor || settings.isShowMHD;
    if (!charter || !isShowPosition) {
        return null;
    }

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!charter.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }
    return (
        <div className={classNames(cls.DaysModeCharter)}>
            <div className={classNames(cls.months)}>
                {months.map((year, i) => (
                    <div className={classNames(cls.months)} key={i}>
                        {year.month.map((item) => (
                            <MonthItemCharter
                                key={item.date}
                                month={item}
                                isPlanFact={isPlanFact}
                                charter={charter}
                            />
                        ))}
                    </div>
                ))}
            </div>
            {opensCharters[charter.guid] && (
                <>
                    {charter.children.map((positionGuid) => (
                        <MonthModePosition
                            key={positionGuid + Math.random().toString(36)}
                            position={positions[positionGuid]}
                        />
                    ))}
                </>
            )}
        </div>
    );
});
